export enum OrderHistoryStatusesEnum {
  NotReceived = 0,
  Received,
  All,
}
